// extracted by mini-css-extract-plugin
export default {"terminal":"Terminal_terminal__aiuoq"};